module.exports = __webpack_public_path__ + "img/slider-4.8864a10d.jpg";